import { render, staticRenderFns } from "./PagesSearch.vue?vue&type=template&id=23ab7671"
import script from "./PagesSearch.vue?vue&type=script&lang=js"
export * from "./PagesSearch.vue?vue&type=script&lang=js"
import style0 from "./PagesSearch.vue?vue&type=style&index=0&id=23ab7671&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports